import React, { useState, useContext, useEffect, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import axios from "../../../../axios/index";
import { Link } from "react-router-dom";

// context
import { UserContext } from "../../../Context/UserContextProvider";

// styles
import styles from "./MeetingDetail.module.css";
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css";
import inputsStyles from "../AddMeeting//AddMeeting.module.css";

// Re Useable Components
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import AddMeetingInput from "../Input/AddMeetingInput";
// import AddMeetingInputDropDown from '../Input/AddMeetingInputDropDown';
import DatePickerInput from "./../Input/DatePickerInput";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import opacity from "react-element-popper/animations/opacity";

//Images
import arrowIcon from "../../../../assets/img/DashboardICons/ArrowRounded.svg";
// import userTestImg from "../../../../assets/img/DashboardICons/userProfileTest.png"
import SeeInvitedPeopleInMeeting from "./SeeInvitedPeopleInMeeting";

// const writtenBy = {
//     name: "ادمین",
//     img: userTestImg,
//     date: new Date().toLocaleDateString('fa-IR')
// }

const MeetingDetail = props => {
  const { state } = useLocation();
  const history = useHistory();
  const { userToken } = useContext(UserContext);
  const [invitedPeople, setInvitedPeople] = useState([]);
  const [btnLoader, setBtnLoader] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [date, setDate] = useState();
  const [time, setTime] = useState();
  const [meetingDetail, setMeetingDetail] = useState();

  useMemo(() => meetingDetail, [meetingDetail]);

  useEffect(() => {
    const dataHandler = async () => {
      const getApiData = await axios.get(`Meeting/${state.id}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(getApiData.data.data)
      setMeetingDetail(getApiData.data.data);
      setDate(getApiData.data.data.createDate);
      const [hour, minute] = getApiData.data.data.meetingTime.split(":");
      setTime(new DateObject().set({ hour, minute }));
      setInvitedPeople(getApiData.data.data.consultants);
    };
    dataHandler();
  }, [state.id, userToken]);

  return (
    <>
      <style type="text/css">
        {`
                .rmdp-wrapper  {
                    background: #F9F9F9 !important;
                }

                .rmdp-arrow {
                    border-color: #D9D9D9 !important;
                }
                `}
      </style>

      <div className="container-fluid">
        <div className="row">
          <div className="col-md-9">
            <div className={`mt-3 px-0 ${Dstyles.container}`}>
              <DashboardHeader />

              {/* head title */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3" dir="rtl">
                    <div className="w-100 d-flex align-items-center justify-content-between flex-wrap mt-4 mb-2">
                      <div className="d-flex align-items-center justify-content-center">
                        <a href="#" onClick={history.goBack}>
                          <img className="ms-2" src={arrowIcon} alt="icon" />
                        </a>
                        <div className={Dstyles.text1}>افزودن جلسه</div>
                      </div>
                      {meetingDetail?.status == 1 ? (
                        <button className={`d-flex align-items-center justify-content-center ms-2 ${styles.cancel_meeting_btn}`} onClick={deleteMeetingHandler}>
                          لغو جلسه
                        </button>
                      ) : meetingDetail?.status == 2 ? (
                        <div className={`d-flex align-items-center justify-content-center ms-2 ${styles.success_meeting_btn}`}>برگزار شده</div>
                      ) : (
                        meetingDetail?.status == 3 && (
                          <div className={`d-flex align-items-center justify-content-center ms-2 ${styles.canceled_meeting_btn}`}>لغو شده</div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* head title */}

              {/* inputs row1 */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                    <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap">
                      <AddMeetingInput title="عنوان جلسه" inputName="title" inputValue={meetingDetail?.title} onChange={changeHandler} />
                      <AddMeetingInput title="رئیس جلسه" inputName="meetingLeader" inputValue={meetingDetail?.meetingLeader} onChange={changeHandler} />
                      {/* <AddMeetingInputDropDown defaultText="رئیس جلسه" inputName="meetingLeader" selectedItem={meetingDetail?.meetingLeader} setState={setMeetingDetail} /> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* inputs row1 */}

              {/* inputs row2 */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                    <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap">
                      <AddMeetingInput title="ناظر" inputName="spectator" inputValue={meetingDetail?.spectator} onChange={changeHandler} />

                      <AddMeetingInput title="مسئول صورت جلسه" inputName="reporter" inputValue={meetingDetail?.reporter} onChange={changeHandler} />

                      {/* <AddMeetingInputDropDown defaultText="مسئول صورت جلسه" inputName="reporter" selectedItem={meetingDetail?.reporter} meetingResponsible setState={setMeetingDetail} /> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* inputs row2 */}

              {/* inputs row3 */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                    <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap">
                      <DatePickerInput date={date} setDate={setDate} />
                      <div className="d-flex align-items-start justify-content-center flex-column my-3">
                        <div className={`mb-2 ${styles.input_top_title}`}>انتخاب زمان</div>
                        <DatePicker
                          value={time}
                          onChange={timeHandler}
                          disableDayPicker
                          format="HH:mm"
                          plugins={[<TimePicker hideSeconds />]}
                          calendar={persian}
                          locale={persian_fa}
                          calendarPosition="bottom-center"
                          animations={[opacity()]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* inputs row3 */}

              {/* inputs row4 */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                    <div className="w-100 d-flex align-items-center justify-content-center flex-wrap">
                      <AddMeetingInput title="مکان جلسه" inputName="address" inputValue={meetingDetail?.address} onChange={changeHandler} fullWidth />
                    </div>
                  </div>
                </div>
              </div>
              {/* inputs row4 */}

              {/* inputs row5 */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                    <div className="w-100 d-flex flex-column justify-content-center align-items-start mb-4">
                      <div className={`mb-3 ${inputsStyles.input_top_title}`}>توضیح</div>
                      <textarea
                        type="text"
                        name="description"
                        className={`w-100 px-3 pt-3 ${inputsStyles.textarea}`}
                        onChange={changeHandler}
                        value={meetingDetail?.description}></textarea>
                    </div>
                  </div>
                </div>
              </div>
              {/* inputs row5 */}

              {/* inputs row6 */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                    <div className="w-100 d-flex flex-column justify-content-center align-items-start mb-4">
                      <div className={`mb-3 ${inputsStyles.input_top_title}`}>دستور جلسه</div>
                      <textarea
                        type="text"
                        name="agenda"
                        className={`w-100 px-3 pt-3 ${inputsStyles.textarea}`}
                        onChange={changeHandler}
                        value={meetingDetail?.agenda}></textarea>
                    </div>
                  </div>
                </div>
              </div>
              {/* inputs row6 */}

              {/* inputs row7 */}
              <SeeInvitedPeopleInMeeting invitedPeople={invitedPeople} setInvitedPeople={setInvitedPeople} />
              {/* inputs row7 */}

              {/* inputs row8 */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                    <div className="w-100 d-flex flex-column justify-content-center align-items-start mb-4">
                      <div className={`mb-3 ${inputsStyles.input_top_title}`}>گزارش جلسه</div>
                      <textarea
                        type="text"
                        name="report"
                        className={`w-100 px-3 pt-3 ${inputsStyles.textarea}`}
                        style={{ height: "244px" }}
                        onChange={changeHandler}
                        value={meetingDetail?.report}></textarea>
                    </div>
                  </div>
                </div>
              </div>
              {/* inputs row8 */}

              {/* inputs row9 */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                    <div className="w-100 d-flex flex-column justify-content-center align-items-start mb-2">
                      <div className={`mb-3 ${inputsStyles.input_top_title}`}>نتیجه جلسه</div>
                      <textarea
                        type="text"
                        name="result"
                        className={`w-100 px-3 pt-3 ${inputsStyles.textarea}`}
                        style={{ height: "322px" }}
                        onChange={changeHandler}
                        value={meetingDetail?.result}></textarea>
                    </div>
                  </div>
                </div>
              </div>
              {/* inputs row9 */}

              {/* written by  */}
              {/* <div className="py-2">
                                <div className="container-fluid">
                                    <div
                                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3"
                                        dir="rtl"
                                    >
                                        <div className='w-100 d-flex align-items-center justify-content-md-start justify-content-between mb-4'>
                                            <div className='d-flex align-items-center justify-content-center ms-md-4'>
                                                <div className={styles.text_gray}>
                                                    نوشته شده توسط:
                                                </div>
                                                <div className='d-flex align-items-center justify-content-center'>
                                                    <img className={`mx-2 ${styles.user_img}`} src={writtenBy.img} alt="user-img" />
                                                    <div className={styles.text_sm_dark}>
                                                        {writtenBy.name}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='d-flex align-items-center justify-content-center me-md-3'>
                                                <div className={styles.text_gray}>
                                                    تاریخ:
                                                </div>
                                                <div>
                                                    <div className={`me-2 ${styles.text_sm_dark}`}>
                                                        {writtenBy.date}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div> */}
              {/* written by  */}

              {/* button group */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                    {btnLoader ? (
                      <div className="w-100 d-flex align-items-center justify-content-md-end justify-content-center my-4 ms-3">
                        <div className={Dstyles.btn_loader_container}>
                          <div className={Dstyles.btn_spinner}></div>
                        </div>
                      </div>
                    ) : (
                      <div className="w-100 d-flex align-items-center justify-content-md-end justify-content-center my-4 ms-3">
                        <button className={`d-flex align-items-center justify-content-center ms-3 ${styles.btn_white}`}>پرینت</button>
                        {meetingDetail?.status == 1 ? (
                          <Link to="/meeting-archive" className={`d-flex align-items-center justify-content-center me-2 ${styles.btn_primary}`}>
                            ذخیره
                          </Link>
                        ) : meetingDetail?.status == 2 ? (
                          <button className={`d-flex align-items-center justify-content-center me-2 ${styles.btn_primary}`} onClick={postHandler}>
                            ذخیره
                          </button>
                        ) : (
                          meetingDetail?.status == 3 && (
                            <button className={`d-flex align-items-center justify-content-center me-2 ${styles.btn_primary}`} onClick={postHandler}>
                              ذخیره
                            </button>
                          )
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* button group */}
            </div>
          </div>
          <div className="col-md-3">
            {/* sideMenu starts */}
            <DashboardSideMenu meeting meetingArchive />
            {/* sideMenu ends */}
          </div>
        </div>
      </div>
    </>
  );

  async function timeHandler(value) {
    setTime(value);
    if (openMenu === true) {
      setOpenMenu(false);
    }
  }

  async function changeHandler(event) {
    setMeetingDetail(prev => {
      return { ...prev, [event.target.name]: event.target.value };
    });
  }

  async function deleteMeetingHandler() {
    var data = {
      id: state.id,
      status: 3,
    };

    const delApiData = await axios.post("Meeting/MeetingStatus", data, {
      headers: { authorization: "Bearer " + userToken },
    });
    // console.log(delApiData)
    history.push("/meeting-archive");
  }

  async function postHandler() {
    setBtnLoader(true);
    const userDate = `${date.year}/${date.month}/${date.day}`;
    const userTime = `${time.hour}:${time.minute}:${time.second}`;
    // console.log(meetingDetail.agenda)
    // console.log(meetingDetail.address)
    var data = new FormData();
    data.append("Id", meetingDetail.id);
    data.append("Title", meetingDetail.title);
    data.append("Description", meetingDetail.description);
    data.append("MeetingDate", userDate);
    data.append("MeetingTime", userTime);
    data.append("Address", meetingDetail.address);
    data.append("MeetingLeader", meetingDetail.meetingLeader);
    for (const usersID of invitedPeople) {
      data.append("ConsultantIds", usersID.id);
    }
    data.append("Spectator", meetingDetail.spectator);
    data.append("Reporter", meetingDetail.reporter);
    for (const userName of invitedPeople) {
      data.append("Invitees", userName.userName);
    }
    data.append("Agenda", meetingDetail.agenda);
    data.append("Report", meetingDetail.report);
    data.append("Result", meetingDetail.result);

    const apiData = await axios.put("Meeting", data, {
      headers: { authorization: "Bearer " + userToken },
    });
    // console.log(apiData);
    history.push("/meeting-archive");
  }
};

export default MeetingDetail;
